module.exports = __webpack_public_path__ + "static/media/mesaage.3b2e1b1b.png";